import React from 'react';

import icon from '../../Resources/Icons/logo_main.svg';
import icon2 from '../../Resources/Icons/earth.svg';
import icon3 from '../../Resources/Icons/Ikonka.png';

import apk from '../../Resources/Files/ALIEN TtT 3.2 x64.apk'

import { Link } from 'react-router-dom';

export default function Developments() {
  return (
    <section className='developments'>
      <div className='cards-container-flex'>
        <div className='card-horizontal'>
          <h2 className='card__title'>Wins. Health. Sport.</h2>
          <p className='card__text'>
            Система для учета занятий спортом и автоматизации работы с тренером.
            Подходит для тренеров и спортсменов занимающихся индивидуально
          </p>
          <p className='card__text'>
            Разработано на основе информационной системы "Для меня" Свидетельство о государственной регистрации №2023661909
          </p>
          <p className='card__text'>
            Группа в VK:
            <span>
              <a
                className='card__link card__link_text'
                href='https://vk.com/whsforme'
                target='_blank'
                rel='noreferrer'
              >
                Перейти в группу
              </a>
            </span>
          </p>
          <p className='card__text'>
            Не упустите шанс сделать свои тренировки более продуктивными. WHS - это ваш личный спортивный
            помощник, который поможет вам воплотить в жизнь ваши самые
            амбициозные мечты. Зарегистрируйтесь сегодня и откройте новые
            горизонты для своей спортивной карьеры!
          </p>
          <p className='card__text'>
            Адрес системы:
            <span>
              <a
                className='card__link card__link_text'
                href='https://whsforme.ru'
                target='_blank'
                rel='noreferrer'
              >
                https://whsforme.ru
              </a>
            </span>
          </p>
          <img
            src={icon}
            className='card__icon card__icon-right'
            alt='Изображение'
          />
        </div>
        {/* Сайты */}
        <div className='card-horizontal'>
          <h2 className='card__title'>Сайты для бизнеса</h2>
          <p className='card__text'>
            Каждый сайт я разрабатываю с любовью и индивидуальным подходом.
            Разработка ведется класическим образом через составление ТЗ.
            Используются различные технологии.
          </p>
          <p className='card__text'>
            Сайт семейного фотографа
            <span>
              <a
                className='card__link card__link_text'
                href='https://www.icanon.ru/'
                target='_blank'
                rel='noreferrer'
              >
                Перейти на сайт
              </a>
            </span>
          </p>
          <p className='card__text'>
            Сайт юридической конторы
            <span>
              <a
                className='card__link card__link_text'
                href='https://pravozashitnik071.ru/'
                target='_blank'
                rel='noreferrer'
              >
                Перейти на сайт
              </a>
            </span>
          </p>
          <p className='card__text'>
            Сайт домашнего кондитера
            <span>
              <a
                className='card__link card__link_text'
                href='https://tulasweets.ru'
                target='_blank'
                rel='noreferrer'
              >
                Перейти на сайт
              </a>
            </span>
          </p>
          <p className='card__text'>
            Сайт компании занимающейся продажей обрезной доски
            <span>
              <a
                className='card__link card__link_text'
                href='https://lesok71.ru/'
                target='_blank'
                rel='noreferrer'
              >
                Перейти на сайт
              </a>
            </span>
          </p>
          <p className='card__text'>
            Сайт компании занимающейся строительством бассейнов
            <span>
              <a
                className='card__link card__link_text'
                href='https://www.skpool.ru/'
                target='_blank'
                rel='noreferrer'
              >
                Перейти на сайт
              </a>
            </span>
          </p>
          <img
            src={icon2}
            className='card__icon card__icon-right'
            alt='Изображение'
          />
        </div>
        {/* Игра */}
        <div className='card-horizontal'>
          <h2 className='card__title'>Alien TTT</h2>
          <p className='card__text'>
            Помогите храброму инопланетянину покинуть планету и отправится в
            путешествие за сокровищами! Наберите 1 000 000 очков уничтожая
            врагов и астероиды, победите охрану планеты и отправьтесь в путь за
            сокровищами.
          </p>
          <p className='card__text'>
            Система управления персонажем действительно уникальна, при коротком
            нажатии на клавишу «вверх» или «вниз» вы задаете импульс кораблю
            инопланетянина, чем дольше нажата клавиша тем сильнее импульс,
            маневрируйте и уничтожайте врагов.
          </p>
          <p className='card__text'>
            П.С. В игре нет аптечек, нет игровыех предметов, которые нужно
            покупать за деньги. Я помню и люблю классику компьютерных игр.
            <span>
              <a
                href={apk}
                target='_blank'
                className='card__link'
                rel='noreferrer'
              >
                Скачать
              </a>
            </span>
          </p>
          <img
            src={icon3}
            className='card__icon card__icon-right'
            alt='Изображение'
          />
        </div>
      </div>
    </section>
  );
}
